export default __webpack_public_path__ + "static/undraw_smart_home_edited-61d6f2bf46d2766f935cf0d12195f94f.svg";